<script>
    export let notebook;
    export let callback;
</script>

{#each Object.entries(notebook.organized_entries) as [section, categorized_entries] }
    {#if section != "0000"}
        <h2>{section}</h2>
        <hr>
    {/if}
    {#each Object.entries(categorized_entries) as [category, entries] }
        <h3>{category}</h3>
        <ul>
        {#each entries as entry }
            <li on:click={() => callback(entry.id)}>{entry.name}</li>
        {/each}
        </ul>
    {/each}
{/each}

<style>
ul {
    padding-left: 20px;
}
li {
    font-size: 18px;
    color: rgb(108, 189, 255);
    list-style-type: none;
}
li:hover {
    cursor: pointer;
}
</style>
